module.exports = __webpack_public_path__ + "static/media/ThumbsDown.9ab28dd5.png";